import React from 'react'
import { Layout, Menu, Dropdown, Avatar } from 'antd'
import { UserOutlined, DownOutlined, LoginOutlined, MessageOutlined } from '@ant-design/icons'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { useLocation, Link } from 'react-router-dom'

import styles from './layout.module.scss'

const { Header } = Layout

const HeaderMenu: React.FC = () => {
  const location = useLocation()
  const needLogin = location.pathname !== '/login'
  const { username } = useSelector((state: any) => {
    return {
      username: state.user.username,
    }
  }, shallowEqual)
  const {
    user: { logout },
  } = useDispatch()

  const menu = (
    <Menu>
      <Menu.Item>
        <div className={styles.userselect}>
          <Link className={styles.textColor} to="/messages">
            <MessageOutlined />
            <span>消息列表</span>
          </Link>
        </div>
      </Menu.Item>
      <Menu.Item>
        <div className={styles.userselect} onClick={() => logout()}>
          <LoginOutlined />
          <span>退出登录</span>
        </div>
      </Menu.Item>
    </Menu>
  )

  return needLogin ? (
    <Header>
      <div className={styles.header}>
        <Link className={styles.logo} to="/group">
          <span></span>
        </Link>
        <Dropdown overlay={menu} className={styles.dropdown}>
          <div className={styles.dropcontent} onClick={(e) => e.preventDefault()}>
            <Avatar size={32} icon={<UserOutlined />} style={{ background: 'rgba(247,249,252,.1)' }} />
            <span className={styles.username}>{username}</span>
            <DownOutlined className={styles.arrow} />
          </div>
        </Dropdown>
      </div>
    </Header>
  ) : (
    <></>
  )
}

export default HeaderMenu
